export default "__VITE_ASSET__PFTypd6p__"